import React from "react";
import { Select, MenuItem, Box } from "@mui/material";
import { PHONE_COUNTRIES } from "../../../config/countries";

/**
 * Dial-code picker for the login phone field. Renders inside an InputAdornment,
 * so it neutralises the outer TextField's outline rules — otherwise the parent's
 * `& fieldset` / 48px height styling cascades in and draws a second border
 * inside the input.
 */
function CountryCodeSelect({ value, onChange, name = "countryCode" }) {
  return (
    <Select
      name={name}
      value={value}
      onChange={onChange}
      variant="outlined"
      renderValue={(dialCode) => (
        <Box component="span" sx={{ fontWeight: 500, color: "#6F767E" }}>
          {dialCode}
        </Box>
      )}
      sx={{
        backgroundColor: "#F8F9FA",
        borderRadius: "8px",
        marginRight: "8px",
        height: "36px",
        minWidth: "88px",
        "& .MuiSelect-select": {
          padding: "6px 8px",
          paddingRight: "24px !important",
          display: "flex",
          alignItems: "center",
        },
        // Kill the nested outline the parent sx would otherwise style.
        "& fieldset": { border: "none" },
        "&:hover fieldset": { border: "none" },
        "&.Mui-focused fieldset": { border: "none" },
        "& .MuiSelect-icon": { right: 2, color: "#6F767E" },
      }}
      MenuProps={{
        PaperProps: { sx: { borderRadius: "12px", marginTop: "4px" } },
      }}
    >
      {PHONE_COUNTRIES.map((country) => (
        <MenuItem key={country.code} value={country.dialCode}>
          <Box
            component="span"
            sx={{ display: "flex", alignItems: "center", gap: "8px" }}
          >
            <span>{country.flag}</span>
            <span style={{ fontWeight: 500 }}>{country.dialCode}</span>
            <span style={{ color: "#6F767E" }}>{country.label}</span>
          </Box>
        </MenuItem>
      ))}
    </Select>
  );
}

export default CountryCodeSelect;
